module.exports = __webpack_public_path__ + "assets/img/12.44fc7411.png";